
export const powerpoint_info = 'Microsoft PowerPoint is a presentation creation software that\'s part of the Microsoft 365 suite. It allows you to create engaging slide decks with text, images, animations, and more.'

export const powerpoint_md = `
# Microsoft PowerPoint  
*Last updated on July 14, 2025*

## Overview

Microsoft PowerPoint is a presentation creation software that's part of the Microsoft 365 suite. 
It allows you to create engaging slide decks with text, images, animations, and more. 
PowerPoint is widely used for meetings, trainings, and professional presentations.

## Benefits
- Easy-to-use tools for designing polished, professional presentations
- Supports multimedia elements including images, videos, and audio
- Presenter view with speaker notes and time tracking
- Seamless collaboration and co-authoring with team members
- Integration with Microsoft 365 apps like Teams, Excel, and OneDrive

## Requirements
- A user account with us
- A valid Microsoft 365 subscription
- An up to date version of Windows

## Getting Started
- PowerPoint gets installed as part of the [Microsoft 365](https://it.bockwaterheaters.com/#/services/m365) suite.

For online access, go to [https://m365.cloud.microsoft/apps/](https://m365.cloud.microsoft/apps/), sign in, and then click on the PowerPoint icon.

## Support
- Contact our [IT Help Desk](https://it.bockwaterheaters.com/#/help)

`